// Opening one item on a portal page from somewhere else: the morning summary's urgent lines
// open the email, disbursement or request they are about, not just its page (Emma, 1 Nov
// 2026).
//
// The summary leaves a note naming the kind of item, its firm and its id, then opens the
// page. The page takes the note when it starts and, once its list has loaded, scrolls to the
// item, marks it and opens it where it can. A note is taken once, and one left untaken (the
// page failed to open) is ignored after a minute, so it never surprises a later visit.

export const FOCUS_KINDS = ["request", "certification", "matter", "diary-entry", "file-request", "fee-slip", "disbursement"];
export const FOCUS_TTL_MS = 60 * 1000;

let pending = null;

export function requestFocus(kind, brand, id, now = Date.now()) {
  pending = FOCUS_KINDS.includes(kind) && id != null && id !== ""
    ? { kind, brand: String(brand || "").toLowerCase(), id: String(id), at: now }
    : null;
}

// The note for this kind of item (and this firm, when the page belongs to one), or null.
export function takeFocus(kind, brand = "", now = Date.now()) {
  const note = pending;
  if (!note || note.kind !== kind) return null;
  if (now - note.at > FOCUS_TTL_MS) {
    pending = null;
    return null;
  }
  const firm = String(brand || "").toLowerCase();
  if (firm && note.brand && note.brand !== firm) return null;
  pending = null;
  return { id: note.id, brand: note.brand };
}

// The attribute a page puts on each item's element, so it can be found and scrolled to.
export const FOCUS_ATTRIBUTE = "data-focus-id";
